<template>
  <div class="read-only">
    <p class="title">{{ title }}</p>
    <div class="d-flex">
      <p class="result">{{ resolvedResult || '-' }}</p>
      <McIconTooltip
        v-if="isError"
        id="isError"
        :icon="'icon-fill_alert-circle'"
        :showTooltip="false"
        variant="danger"
        placement="bottom"
        class="ms-2"
      />
    </div>
  </div>
</template>

<script>
import McIconTooltip from '@/components/McIconTooltip'
export default {
  name: 'ReadOnly',
  components: {
    McIconTooltip,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    result: {
      type: [String, Function],
      default: '-',
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resolvedResult() {
      return typeof this.result === 'function' ? this.result() : this.result
    },
  },
}
</script>

<style lang="scss" scoped>
.read-only {
  margin-top: 25px;
  .title {
    color: $teal-300;
    margin: 0px;
  }
  .result {
    color: $mep-color-text;
    margin: 0px;
  }
}
</style>
